module.exports = __webpack_public_path__ + "img/hog.93721789.svg";